import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AUTHENTICATED_ENTRY } from "configs/AppConfig";
import { authStore } from "stores/auth.store";

const PublicRoute = () => {
  const token = authStore.getState().token;

  return token ? <Navigate to={AUTHENTICATED_ENTRY} /> : <Outlet />;
};

export default PublicRoute;
